import * as React from 'react';
import ModulePositionContainer from '../../_containers/ModulePositionContainer';
import ModuleDimensionsContainer from '../../_containers/ModuleDimensionsContainer';
import ModuleRotationContainer from '../../_containers/ModuleRotationContainer';
import ModuleColorContainer from '../../_containers/ModuleColorContainer';
import ModuleDuplicateContainer from '../../_containers/ModuleDuplicateContainer';

export type Props = {
	moduleId?: string
	width?: number
	height?: number
	onWidthChange?: Function
	onHeightChange?: Function
}

export default class ModuleRectangleSettings extends React.Component<Props> {
	render = () => <>
		<ModuleColorContainer moduleId={this.props.moduleId}/>
		<ModulePositionContainer moduleId={this.props.moduleId}/>
		<ModuleDimensionsContainer moduleId={this.props.moduleId}/>
		<ModuleRotationContainer moduleId={this.props.moduleId}/>

		<div className="actions-wrapper">
			<ModuleDuplicateContainer moduleId={this.props.moduleId}/>
		</div>
	</>
}